import { Injectable, inject } from "@angular/core";
import { CanActivate, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { LorenAuthenticationService } from "../../../../shared/services/loren-authentication-service/loren-authentication.service";
import { LOREN_ROUTES } from "../../../../shared/constants/loren-routes.constants";

@Injectable({
  providedIn: "root",
})
export class LorenLoginGuard implements CanActivate {
  private authenticationService = inject(LorenAuthenticationService);
  private router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authenticationService.isAuthenticated()) {
      this.router.navigate([LOREN_ROUTES.DASHBOARD]);
      return false;
    }
    return true;
  }
}
